/**
 * Unified source for the possible payment quantities in the PaymentData screen.
 */
export const ANNUAL = 'anual';
export const OTHER = 'en cuotas';
